import * as pageTypes from '../types/Page';

const INITIAL_STATE = { 
    selected: "btnCustomer",
    customerCompleted: false,
    positionsCompleted: false
};

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case pageTypes.PAGE_GO_TO_START_PAGE: 
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
            return INITIAL_STATE;
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_CUSTOMER_PAGE:
            return {
                ...state,
                selected: "btnCustomer"
            };
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return {
                ...state,
                positionsCompleted: false
            };
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_POSITION_PAGE:
            return {
                ...state,
                selected: "btnPositions"
            };    
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/CreateComplaintMenu.js